<template>
    <div v-if="indicatorName && level" style="display: flex; justify-content: space-between; align-items: center;" class="horizontal-divider">
        <div class="client">
            <h3 class="text-capitalize title" :title="indicatorName">{{ indicatorName }}</h3>
            <p>Track {{ level }} progress here</p>
        </div>
        <div style="display: flex; gap: 20px; width: 25%; justify-content: end;" v-if="Object.keys(brandIndicators).length">
            <div>
                <div class="indicator">{{ translatedLang['Review Count'][selectedLanguage.key] }}</div>
                <div class="indicator-val">{{ formatNumber(brandIndicators.count) }}</div>
            </div>
            <div v-if="brandIndicators.percentage" style="border-left: 2px solid #D9D9D9; padding-left: 20px;">
                <div class="indicator">{{ translatedLang['Market Share'][selectedLanguage.key] }}</div>
                <div class="indicator-val">{{ brandIndicators.percentage }}%</div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
    name: "BrandIndicator",
    props: {
        level: {
            type: String,
            required: true
        },
        indicatorName: {
            type: String,
            required: true
        },
        brandIndicators: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        ...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),
    },
    methods: {
        ...mapActions("DemoStore", [
            "setSelectedLanguage",
            "initializeTranslation",
        ]),
        formatNumber(number) {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
    }
}
</script>
<style>
.title {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
}

.indicator {
    font-family: Poppins;
    font-size: 14px;
    font-weight: 400;
    color: #5E5E5E;
}

.indicator-val {
    font-family: Poppins;
    font-size: 16px;
    font-weight: 600;
    color: #5E5E5E;
}

.client h3 {
    font-family: Poppins;
    font-size: 32px;
    font-weight: 500;
    line-height: 43.52px;
    letter-spacing: -0.01em;
}

.client p {
    font-family: Poppins;
    font-size: 16px;
    font-weight: 500;
    line-height: 21.76px;
    letter-spacing: -0.01em;
}
</style>